import ListFilter from 'Shared/components/list-filter';

const pieChartFilter = (invoice, { pieChartLabelWithIndex }) => (pieChartLabelWithIndex === null ? true : pieChartLabelWithIndex.startsWith(invoice.filterStatus));

const DebtorsFilter = (props) => (
  <ListFilter
    {...props}
    filterActions={[
      pieChartFilter,
    ]}
  />
);

export default DebtorsFilter;
